/* eslint-disable react/jsx-no-target-blank */
import BakeryDiningIcon from "@mui/icons-material/BakeryDining";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import LogoutIcon from "@mui/icons-material/Logout";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import MessageIcon from "@mui/icons-material/Message";
import TwitterIcon from "@mui/icons-material/Twitter";
import {
  AppBar,
  Avatar,
  Button,
  IconButton,
  MenuList,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import GoogleLogin, { GoogleLogout } from "react-google-login";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import "./Header.css";

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: "transparent !important",
    boxShadow: "none !important",
  },
  appBarColored: theme.appBarColored,
  title: {
    color: theme.header.color,
    fontWeight: theme.header.fontWeight,
    cursor: "pointer",
  },
  hamburgerIcon: {
    color: theme.header.color,
  },
  menuIcon: {
    color: theme.header.color,
    fontWeight: "500 !important",
  },
  activeMenu: {
    borderBottom: "2px solid white !important",
  },
}));

export const appVisitTelemetry = async (pageName) => {
  fetch(
    `https://perpverse-default-rtdb.asia-southeast1.firebasedatabase.app/telemetry-page-visit.json`,
    {
      method: "POST",
      body: JSON.stringify({
        sessionId: window.sessionId,
        sigInTime: new Date(),
        pageName: pageName,
      }),
    }
  );
};

const uniqueAppVisitTelemetry = async () => {
  fetch(
    `https://perpverse-default-rtdb.asia-southeast1.firebasedatabase.app/telemetry-app-visit.json`,
    {
      method: "POST",
      body: JSON.stringify({
        sessionId: window.sessionId,
        sigInTime: new Date(),
      }),
    }
  );
};

const saveData = async (data) => {
  fetch(
    `https://perpverse-default-rtdb.asia-southeast1.firebasedatabase.app/users.json`,
    {
      method: "POST",
      body: JSON.stringify(
        data?.Du && data?.Du?.VX
          ? {
              [data.Du.VX]: {
                firstName: data.Du.VX,
                lastName: data.Du.iW,
                email: data.Du.tv,
                profileImage: data.Du.eN,
                fullName: data.Du.tf,
                id: data.Du.FW,
                time: new Date(),
              },
            }
          : data
      ),
    }
  ).then(() => {
    window.isAuthenticated = true;
  });
};

const Header = (props) => {
  const [colorChange, setColorchange] = useState(false);
  const [user, setUser] = useState({});
  const [setOpenCookieMessage] = useState(false);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [theme, setTheme] = useState("dark");
  const [nav, setNav] = useState(
    sessionStorage.getItem("last_selected") || "DSA"
  );

  useEffect(() => {
    const cookies = document.cookie;
    const prepverseCookie = cookies
      .split("; ")
      .filter((cookie) => cookie.includes("prepverse.net"));
    const userSession =
      prepverseCookie.length > 0 ? prepverseCookie[0].split("=")[1] : uuidv4();
    document.cookie = `prepverse.net=${userSession}; someCookieName=true; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
    window.sessionId = userSession;
    uniqueAppVisitTelemetry();
  }, []);

  const changeNavbarColor = () => {
    if (window.scrollY >= 10) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };
  window.addEventListener("scroll", changeNavbarColor);
  const classes = useStyles();
  const navigate = useNavigate();

  const updateUserState = (user) => {
    setUser(user);
    if (Object.keys(user).length !== 0) {
      saveData(user);
    }
  };

  const handleCloseNavMenu = (page) => {
    setAnchorElNav(null);
    if (page !== "DSA" && page !== "About" && page !== "Videos") {
      page = "DSA";
    }
    if (page === "Home" || page === "DSA") {
      navigate("/");
    } else if (page === "About") {
      // navigate("/about");
    } else if (page === "Videos") {
      navigate("/videos");
    }
    sessionStorage.setItem("last_selected", page);
    setNav(page);
  };
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  return (
    <Box sx={{ flexGrow: 1 }} className="navigation-bar">
      <AppBar
        position="sticky"
        className={colorChange ? classes.appBarColored : classes.appBar}
      >
        <Toolbar>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              className={`${classes.menuIcon}`}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={() => handleCloseNavMenu(nav)}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {["Home", "DSA", "Videos"].map((page) => (
                <MenuItem key={page} onClick={() => handleCloseNavMenu(page)}>
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
              {
                <MenuList>
                  <a
                    href="https://twitter.com/prep_verse"
                    target="_blank"
                    style={{ textDecoration: "none", color: "unset" }}
                  >
                    <MenuItem
                      key={"Contact"}
                      onClick={() => handleCloseNavMenu("mail")}
                    >
                      <Typography textAlign="center">
                        {"Twitter"}
                        <TwitterIcon className="ms-2" />
                      </Typography>
                    </MenuItem>
                  </a>
                  <a
                    href="mailto:contact.prepverse@gmail.com"
                    target="_blank"
                    style={{ textDecoration: "none", color: "unset" }}
                  >
                    <MenuItem
                      key={"Contact"}
                      onClick={() => handleCloseNavMenu("mail")}
                    >
                      <Typography textAlign="center">
                        {"mail"}
                        <MailIcon className="ms-2" />
                      </Typography>
                    </MenuItem>
                  </a>
                  <a
                    href="https://join.slack.com/t/prepverse/shared_invite/zt-12cmeti9i-u2L2J6qE_O3~in4O84pbaA"
                    target="_blank"
                    style={{ textDecoration: "none", color: "unset" }}
                  >
                    <MenuItem
                      key={"Contact"}
                      onClick={() => handleCloseNavMenu("Contact")}
                    >
                      <Typography textAlign="center">
                        {"Contact"}
                        <MessageIcon className="ms-2" />
                      </Typography>
                    </MenuItem>
                  </a>
                </MenuList>
              }
            </Menu>
          </Box>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
            className={`${classes.title}`}
            onClick={() => {
              handleCloseNavMenu("Home");
            }}
          >
            <BakeryDiningIcon className="logo-icon" /> Prepverse
          </Typography>
          <Box sx={{ flexGrow: 30, display: { xs: "none", md: "flex" } }}>
            {["DSA", "Videos"].map((page) => (
              <Button
                key={page}
                onClick={() => handleCloseNavMenu(page)}
                className={`${classes.menuIcon} ms-5 ${
                  nav === page && classes.activeMenu
                }`}
                sx={{ my: 2, display: "block" }}
              >
                {page}
              </Button>
            ))}
          </Box>
          <Tooltip title="theme">
            <IconButton
              className={`${classes.menuIcon} me-2`}
              onClick={() => {
                let theme_current = theme === "light" ? "dark" : "light";
                setTheme(theme_current);
                props.currentTheme(theme_current);
              }}
            >
              <Brightness4Icon />
            </IconButton>
          </Tooltip>
          <Tooltip title="twitter">
            <a
              href="https://twitter.com/prep_verse"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <IconButton
                className={`${classes.menuIcon} me-2`}
                sx={{ flexGrow: 30, display: { xs: "none", md: "flex" } }}
              >
                <TwitterIcon />
              </IconButton>
            </a>
          </Tooltip>
          <Tooltip title="mail">
            <a
              href="mailto:contact.prepverse@gmail.com"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <IconButton
                className={`${classes.menuIcon} me-2`}
                sx={{ flexGrow: 30, display: { xs: "none", md: "flex" } }}
              >
                <MailIcon />
              </IconButton>
            </a>
          </Tooltip>
          <Tooltip title="contact - slack">
            <a
              href="https://join.slack.com/t/prepverse/shared_invite/zt-12cmeti9i-u2L2J6qE_O3~in4O84pbaA"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <IconButton
                className={`${classes.menuIcon} me-4`}
                sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
              >
                <MessageIcon />
              </IconButton>
            </a>
          </Tooltip>

          {Object.keys(user).length === 0 ? (
            <GoogleLogin
              clientId="481531433357-0rdtul9gnf4720ktlpgaej9g6456slkp.apps.googleusercontent.com"
              buttonText="Login"
              // uxMode="redirect"
              onSuccess={(response) => {
                updateUserState(response);
              }}
              onFailure={(response) => {
                setOpenCookieMessage(true);
              }}
              isSignedIn={true}
              cookiePolicy={"single_host_origin"}
            />
          ) : (
            <GoogleLogout
              clientId="481531433357-0rdtul9gnf4720ktlpgaej9g6456slkp.apps.googleusercontent.com"
              buttonText="Logout"
              render={(renderProps) => (
                <IconButton
                  className={`${classes.menuIcon} me-2`}
                  onClick={renderProps.onClick}
                  disabled={renderProps.disabled}
                >
                  <Tooltip title="Log out">
                    <LogoutIcon />
                  </Tooltip>
                </IconButton>
              )}
              onLogoutSuccess={() => {
                updateUserState({});
              }}
            ></GoogleLogout>
          )}
          {Object.keys(user).length > 0 && (
            <>
              <Tooltip title={user?.Du?.tf || ""}>
                <Avatar src={user?.Du?.eN} />
              </Tooltip>
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
